
export const HOME = '/'
export const CONTACT = '/contact-us';
export const TERMS = '/terms';
export const REFUND = '/refund';
export const ABOUT = '/about-us'